class Controller {
}

export {
    Controller
};
